import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Role } from '../enums/role.enum';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const allowedRoles: Role[] = route.data['roles'] || [];
  const userRole = auth.userRole();

  if (userRole && allowedRoles.includes(userRole)) {
    return true;
  }

  // Redirect to their correct dashboard
  auth.redirectToDashboard();
  return false;
};
